import React from 'react';
import useSettings from '../utils/useSettings';

const MaintenancePage = ({ message: propMessage }) => {
  const { settings } = useSettings();
  const message = propMessage || settings.maintenanceMode?.message
    || "We're doing some quick maintenance to make Dreamy Bedtime even better for your family. We'll be back very shortly!";

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a0533 0%, #2d1b69 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
    }}>
      <div className="text-center text-white" style={{ maxWidth: '480px' }}>
        <div style={{ fontSize: '72px', marginBottom: '24px' }} className="float-anim">🌙</div>
        <h1 style={{ fontFamily: "'Fredoka One',cursive", fontSize: 'clamp(28px,5vw,42px)', marginBottom: '16px' }}>
          Back in a moment…
        </h1>
        <p style={{ color: '#c9a8ff', fontSize: '17px', lineHeight: 1.7, marginBottom: '32px' }}>
          {message}
        </p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          {['🛠️ Quick maintenance', '⏱️ Back soon', '✨ Worth the wait'].map(t => (
            <span key={t} className="badge rounded-pill px-3 py-2"
              style={{ background: 'rgba(255,255,255,0.1)', color: '#c9a8ff', fontSize: '13px' }}>
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
